import React from 'react'
import generalClasses from '../../Auth/signup.module.css'
import loginImage from '../../../assets/images/beneficiary-invite-image.jpg'
import { ReactComponent as ArrowRight } from '../../../assets/icons/arrow-right.svg'
import { ValidatedLoginInput } from '../../../components/Form/Inputs/Inputs'
import { Button, ButtonIcon } from '../../../components/Button/Button'
import { useDispatch } from 'react-redux'
import useAuthForm from '../../../hooks/useAuthForm'
import { Formik } from 'formik'
import { SignUpSchema } from '../../../util/formSchemas'
import { signUpBeneficiary } from '../../../api/authApi'
import useCompanyLogo from '../../../hooks/useCompanyLogo'
import { getImageURL } from '../../../util/functions'
import Loading from '../../../components/loaders/Loading'
import { Redirect } from 'react-router'
import { UserTypes } from '../../../util/constants'

export const BeneficiaryTop = ({ logoProps }) => {
    const { logo, isFetching, hasError, companyName } = logoProps

    return (
        !isFetching && (
            <>
                {!hasError && logo && (
                    <img
                        src={getImageURL(logo)}
                        alt="Logo"
                        className={generalClasses.formLogo}
                    />
                )}
                {!logo && (
                    <p className={generalClasses.formCompany}>{companyName}</p>
                )}
            </>
        )
    )
}

const BeneficiarySignUp = ({ location, history, match }) => {
    const email = new URLSearchParams(location.search).get('email')

    const dispatch = useDispatch()

    const submitForm = values => {
        //Adding the email field from the url in case the user tampers with the actual input
        dispatch(signUpBeneficiary({ ...values, email }))
    }

    const { domainName } = match.params

    useAuthForm(
        () => {
            history.push(`/app/auth/sign-in`)
        },
        false,
        UserTypes.Beneficiary
    )

    const logoProps = useCompanyLogo(domainName)

    if (logoProps.isFetching) {
        return <Loading />
    }

    if (logoProps.has404Error) {
        // return (
        //     <Redirect
        //         to={{
        //             pathname: '/app/404',
        //             state: { finalDestination: true },
        //         }}
        //     />
        // )
    }

    return (
        <div className={generalClasses.container}>
            <Formik
                initialValues={{
                    firstname: '',
                    lastname: '',
                    email: email,
                    password: '',
                    confirmPassword: '',
                    jobTitle: '',
                    phonenumber: '',
                }}
                onSubmit={submitForm}
                validationSchema={SignUpSchema}
            >
                {({ handleSubmit }) => (
                    <div className={generalClasses.form}>
                        <BeneficiaryTop logoProps={logoProps} />
                        <h1 className={generalClasses.formHeader}>
                            Sign up to start learning
                        </h1>
                        <div className={generalClasses.formInputs}>
                            <div className={generalClasses.formRow}>
                                <ValidatedLoginInput
                                    name={'firstname'}
                                    placeholder={'First Name'}
                                />
                                <ValidatedLoginInput
                                    name={'lastname'}
                                    placeholder={'Last Name'}
                                />
                            </div>
                            <ValidatedLoginInput
                                placeholder={'Email Address'}
                                value={email}
                                name={'email'}
                                disabled
                            />
                            <ValidatedLoginInput
                                placeholder={'Phone Number'}
                                name={'phonenumber'}
                            />
                            <ValidatedLoginInput
                                name={'password'}
                                type={'password'}
                                placeholder={'Password'}
                            />
                            <ValidatedLoginInput
                                name={'confirmPassword'}
                                type={'password'}
                                placeholder={'Confirm Password'}
                            />
                        </div>
                        <Button
                            className={generalClasses.formButton}
                            bold={false}
                            smallRadius
                            onClick={handleSubmit}
                        >
                            Get Started
                            <ButtonIcon icon={<ArrowRight />} />
                        </Button>
                        <span className={generalClasses.formSplitLine} />
                        <p className={generalClasses.formSignInText}>
                            Already have an account?{' '}
                            <span
                                className={generalClasses.formSignInTextOrange}
                            >
                                Sign In
                            </span>
                        </p>
                    </div>
                )}
            </Formik>
            <img
                src={loginImage}
                alt="Login Page Background"
                className={generalClasses.displayImage}
            />
        </div>
    )
}

export default BeneficiarySignUp
